/**
 * ADR 131 — ventana dinámica de Entrega Express en las TARJETAS del grid.
 *
 * El badge "⚡ Express" de cada tarjeta debe significar "hay algo express que
 * ofrecerte hoy", no "este producto tiene express configurado". Sin esto, la
 * tarjeta prometía express todos los días mientras que la ficha solo mostraba
 * la promesa la víspera de la visita — seis días de cada siete el comprador
 * veía el badge y al entrar no encontraba nada que lo explicara.
 *
 * Regla: se enciende si hay envío express nacional (que no depende del día) o
 * si hoy es la víspera de la visita de algún punto de pickup.
 *
 * El badge nace oculto en Liquid y este script lo enciende. En ese orden a
 * propósito: si el script no corriera, preferimos no prometer express a
 * prometerlo sin poder cumplirlo.
 *
 * El día se calcula en el navegador y en zona horaria de México — igual que el
 * panel de la PDP. No se hace en Liquid porque el HTML se cachea y el día
 * quedaría congelado del lado del servidor.
 */
(function () {
  function diaEnMexico() {
    try {
      var wd = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Mexico_City',
        weekday: 'short',
      }).format(new Date());
      return { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[wd];
    } catch (e) {
      return undefined; // sin fecha confiable no se enciende ninguna promesa
    }
  }

  function aplicar() {
    var dow = diaEnMexico();
    if (dow === undefined) return;

    document.querySelectorAll('[data-express-badge]').forEach(function (badge) {
      var dias = (badge.dataset.expressDays || '')
        .split(',')
        .filter(Boolean)
        .map(Number);
      var vispera = dias.some(function (d) {
        return dow === (d + 6) % 7;
      });
      badge.hidden = !(badge.dataset.expressNational === '1' || vispera);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', aplicar);
  } else {
    aplicar();
  }

  /* Las colecciones cargan tarjetas nuevas al filtrar o paginar, y llegan
     ocultas. Un observer sobre el body las alcanza sin acoplarse a la sección. */
  if (window.MutationObserver) {
    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        aplicar();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
